import { gql } from "@medbillai/generated-graphql-types";

// The only query that selects `referralCode`: reading it mints the code, so
// the sheet runs it on open rather than Home on every load.
export const getReferralCodeQuery = gql(/* GraphQL */ `
  query GetReferralCode {
    me {
      id
      referralCode
    }
  }
`);

export const getReferredSignupQuery = gql(/* GraphQL */ `
  query GetReferredSignup {
    me {
      id
      attribution
    }
  }
`);
